import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from '@cpak/main-features-lib/services';
import { WINDOW } from '@cpak/shared/injectors';
import { BFFAuthenticateResponsePayload } from '@cpak/adp-cpak-bff-service-models';

@Injectable({
  providedIn: 'root',
})
export class AuthRepositoryService {
  constructor(@Inject(WINDOW) private window: Window, private fetcher: FetcherService) {}

  public refreshAuthToken(): Observable<void | null> {
    return this.fetcher.put('/api/auth/token');
  }

  public login(state: string, code: string, codeVerifier: string): Observable<BFFAuthenticateResponsePayload | null> {
    const localhost = 'local.designer.dev.digital.alconcloud.com';
    const redirectUri =
      this.window.location.hostname === localhost ? `http://${localhost}:9999/login/callback` : undefined;

    return this.fetcher.post<BFFAuthenticateResponsePayload>('/api/auth/token', {
      code,
      state,
      codeVerifier,
      redirectUri,
    });
  }
}
